<template>
  <div>
    <div class="col-12 pr-0 pl-0" v-if="claim.claim_status.name === 'Closed'">
      <div class="claim-resolved-indicator-wrap">
        <div class="col-9 px-0 flex">
          <span class="fa fa-clipboard d-block" />
          <h3 class="text">
            Closed claim ({{ claim.claim_resolution.name }}) - {{ claim.title }}
          </h3>
        </div>
        <div class="col-3 px-0 text-right d-flex justify-content-end" v-if="($_can('claims.update') || $_can('claims.view-own'))">
          <router-link :to="`/claims/edit/${claim.id}`" class="d-flex">
            <p>See claim</p>
          </router-link>
        </div>
      </div>
    </div>

    <div v-else class="col-12 pr-0 pl-0">
      <div class="claim-indicator-wrap">
        <div class="col-9 px-0 flex">
          <span class="fa fa-clipboard" />
          <h3 class="text">
            Unresolved claim - {{ claim.title }}
          </h3>
        </div>
        <div class="col-3 px-0 text-right d-flex justify-content-end" v-if="($_can('claims.update') || $_can('claims.view-own'))">
          <router-link :to="`/claims/edit/${claim.id}`" class="d-flex">
            <p class="d-none d-lg-block d-md-block d-xl-block">See claim</p>
            <i class="fa fa-arrow-right" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped>
.text {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobClaimBanner.vue